module.exports = __webpack_public_path__ + "955947cd40875fcf7c368917c27bad8b.MP3";